import { PickingTaskDetailPage } from '@/features/picking-task/pages/PickingTaskDetailPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/picking-task/$id/detail')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["picking_task.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: PickingTaskDetailPage,
})
